export default __webpack_public_path__ + "static/media/partners-header.938fdf5e.jpg";